import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { forgotPassword } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, MailCheck } from "lucide-react";

function Shell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid place-items-center bg-[#17324D] p-6">
      <div className="w-full max-w-sm rounded-xl border border-white/10 bg-background p-7">
        <div className="mb-6 flex items-center justify-center rounded-lg bg-[#17324D] px-6 py-6 shadow-sm">
          <img src="/fo-logo-light-trimmed.png" alt="Fortunate Operations" className="w-full max-w-[300px] h-auto object-contain" data-testid="auth-brand-logo" />
        </div>
        <h2 className="font-heading text-2xl font-bold tracking-tight">{title}</h2>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
        <div className="mt-6">{children}</div>
      </div>
    </div>
  );
}

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await forgotPassword(email);
    setLoading(false);
    setSent(true);
  };

  return (
    <Shell title="Reset your password" subtitle="Enter your email and we'll send a reset link.">
      {sent ? (
        <div className="space-y-4">
          <div className="flex items-center gap-2 rounded-md bg-emerald-50 px-3 py-3 text-sm text-emerald-700 ring-1 ring-emerald-200" data-testid="forgot-success">
            <MailCheck className="h-5 w-5" /> If an account exists, a reset link has been sent.
          </div>
          <Button variant="outline" className="w-full" onClick={() => navigate("/login")}>Back to sign in</Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label>Email</Label>
            <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit">
            {loading ? "Sending…" : "Send reset link"}
          </Button>
          <Link to="/login" className="flex items-center justify-center gap-1 text-sm text-muted-foreground hover:text-foreground">
            <ArrowLeft className="h-3.5 w-3.5" /> Back to sign in
          </Link>
        </form>
      )}
    </Shell>
  );
}

export { Shell };
